export const sentence = [
  "He loves to play basketball",
  "My father goes to his office by bus",
  "My sister drinks a glass of milk every morning",
  "He goes to school",
  "She enjoys playing the piano",
  "My mother is cooking chicken soup in the kitchen now",
  "We are playing football in the school yard",
  "He thinks he is very handsome",
  "It usually rains every day here",
  "It smells very delicious in the kitchen",
  "We learn english at English Online everyday",
  "I usually read some books in the morning",
  "The flower is red",
  "She was busy last night",
  "The baby is going to sleep",
  "We generally sing songs all together",
  "We go to a gallery every Sunday",
  "The sun rises at the east",
  "Today is not a holiday",
  "Tom is riding an Australian horse very fast",
  "She is singing with her sister",
  "I will give it some of my food",
  "She goes to work by car",
  "We go to the gym club together",
  "She lends us some money to buy some clothes",
  "They sleep in the afternoon",
  "The earth goes round the sun",
  "He sends some watches to you",
  "George brushes his teeth twice a day",
  "He gets up early every day",
  "You know how it flies",
  "I attend a meeting",
  "She dances traditional dance",
  "I like reading detective stories",
  "Every child likes an icecream",
  "You go to holiday every summer",
  "My daughter does the laundry",
  "My brother takes out the trash",
  "The course starts next Sunday",
  "She swims every morning",
  "We see them every week",
  "She always forgets her purse",
  "She wants to be a dentist",
  "Cows eat grass",
  "She has a beehive full of bees",
  "My cat runs very fast",
  "My son lives in London",
  "He catches the train every morning",
  "My sister works at the theater",
  "My boyfriend loves this song",
  "He goes to football every day",
  "California is not in the United Kingdom",
  "The Queen of England lives in Buckingham Palace",
  "Julie talks very fast",
  "I love my new pets",
  "We drink coffee every morning",
  "My Dad never works on the weekends",
  "He drives to work",
  "She likes bananas",
  "I run four miles every morning",
  "They speak English at work",
  "I have no money at the moment",
  "Tomorrow early morning first I go to morning walk",
  "You run to the party",
  "You have some schoolwork to do",
  "The train leaves in ten minutes",
  "Nurses work in clinics and hospitals",
  "I do not like meat",
  "They go to a gallery every Saturday",
  "He goes to school every morning",
  "She understands English",
];
